import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";
import { NOTIFICATION_ROUTES } from "static/constants";

const buildNotificationUrl = (type, metadata) => {
  const base = NOTIFICATION_ROUTES[type];
  if (!base) return null;
  if (!metadata || typeof metadata !== "object") return base;

  const params = new URLSearchParams(
    Object.entries(metadata).filter(([, v]) => v !== null && v !== undefined)
  ).toString();

  return params ? `${base}?${params}` : base;
};

export const getNotifications = async ({
  page = 1,
  limit = 20,
  userId,
} = {}) => {
  const { data } = await api.get(endpoints.notification.list, {
    params: { page, limit },
  });

  const notifications = (data.notifications ?? []).map((n) => {
    const metadata = n.metadata ?? {};
    const recipient = n.recipients?.find((r) => r.user?._id === userId);
    return {
      id: n._id,
      type: n.type,
      message: n.message,
      senderName: n.recipients?.[0]?.user?.name ?? "",
      isRead: recipient?.is_read ?? false,
      createdAt: n.created_at,
      metadata,
      url: buildNotificationUrl(n.type, metadata),
    };
  });

  return {
    notifications,
    unreadCount: data.unreadCount ?? 0,
    itemsCount: data.itemsCount ?? 0,
    page: data.page,
    limit: data.limit,
  };
};

export const markAllNotificationsRead = async () => {
  const { data } = await api.patch(endpoints.notification.markAllRead);
  return data;
};

export const markNotificationRead = async (id) => {
  const url = interpolate(endpoints.notification.markRead, { id });
  const { data } = await api.patch(url);
  return data;
};
